// Centralized helper formatters and constants
export const STAGES = [
  { key: "new", label: "New" },
  { key: "qualified", label: "Qualified" },
  { key: "research", label: "Needs Research" },
  { key: "disqualified", label: "Disqualified" },
  { key: "outreach", label: "In Outreach" },
  { key: "engaged", label: "Engaged" },
  { key: "agreement_sent", label: "Agreement Sent" },
  { key: "agreement_signed", label: "Agreement Signed" },
  { key: "filed", label: "Filed w/ Court" },
  { key: "approved", label: "Approved" },
  { key: "disbursed", label: "Disbursed" },
  { key: "denied", label: "Denied" },
  { key: "unresponsive", label: "Unresponsive" },
];

export const STAGE_COLORS = {
  new: "bg-slate-100 text-slate-800 border-slate-200",
  qualified: "bg-emerald-100 text-emerald-800 border-emerald-200",
  research: "bg-amber-100 text-amber-800 border-amber-200",
  disqualified: "bg-slate-100 text-slate-500 border-slate-200",
  outreach: "bg-blue-100 text-blue-800 border-blue-200",
  engaged: "bg-indigo-100 text-indigo-800 border-indigo-200",
  agreement_sent: "bg-violet-100 text-violet-800 border-violet-200",
  agreement_signed: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
  filed: "bg-cyan-100 text-cyan-800 border-cyan-200",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-200",
  disbursed: "bg-emerald-600 text-white border-emerald-700",
  denied: "bg-red-100 text-red-800 border-red-200",
  unresponsive: "bg-slate-100 text-slate-600 border-slate-200",
};

export function stageLabel(key) {
  return STAGES.find(s => s.key === key)?.label || key;
}

export function money(n) {
  if (n == null || isNaN(n)) return "—";
  return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
}

export function fmtDate(s) {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString(); } catch { return s; }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try { return new Date(s).toLocaleString(); } catch { return s; }
}

export function initials(name) {
  if (!name) return "?";
  return name.split(/\s+/).filter(Boolean).slice(0,2).map(s => s[0]?.toUpperCase()).join("");
}
